<template>
  <div :style="{direction: dir}">
    <sup v-if="unit && ! isoUnit">{{unit}}</sup> {{sign}}{{whole | comma-separate}}<span v-if="decimal && !hideDecimals"
                                                                                         class="decimals">.</span><span class="decimals"
                                                                                                                        v-if="!hideDecimals">{{decimal}}</span>
    <span v-if="decimal && !hideDecimals && zeroPads"><span v-for="(i, index) in (zeroPads)" :key="index"
                                                            class="decimals">0</span></span>
    <span v-if="!hideWhiteSpaces"><span v-for="(i, index) in (decimalMaxLength - decimal.length - zeroPads)"
                                        class="decimals invisible"
                                        :key="index"
    >0</span></span>

    <small v-if="unit && isoUnit" :class="unitClass"> {{unit}}</small>
  </div>
</template>

<script>
export default {
  name: 'CurrencyFormat',
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    unit: {
      type: String,
      default: ''
    },
    isoUnit: {
      type: Boolean,
      default: true
    },
    unitClass: {
      type: String,
      default: ''
    },
    sign: {
      type: String,
      default: ''
    },
    hideDecimals: {
      type: Boolean,
      default: false
    },
    hideWhiteSpaces: {
      type: Boolean,
      default: true
    },
    rightZeroPad: {
      type: Number,
      default: 2
    },
    decimalMaxLength: {
      type: [String, Number],
      default: 8
    },
    hideZeroDecimal: {
      type: Boolean,
      default: false
    },
    dir: {
      type: String,
      default: 'ltr'
    }
  },
  computed: {
    whole () {
      return this.value.toString().split('.')[0]
    },
    decimal () {
      const defaultDecimal = this.hideZeroDecimal ? '' : '0'
      return parseFloat(parseFloat(this.value).toFixed(parseInt(this.decimalMaxLength))).toString().split('.')[1] || defaultDecimal
    },
    zeroPads () {
      return this.decimal.length && (this.rightZeroPad - this.decimal.length) > 0 ? (this.rightZeroPad - this.decimal.length) : 0
    }
  },
  data () {
    return {}
  },
  methods: {},
  created () {
  },
  mounted () {
  },
  components: {}
}
</script>

<style scoped>
  .decimals {
    font-size: 0.8em;
    font-weight: normal;
    vertical-align: baseline;
    top: 0.05em;
    position: relative;
  }

  .invisible {
    opacity: 0;
  }
</style>
